/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InputWindLabPoint } from './InputWindLabPoint';
import {
    InputWindLabPointFromJSON,
    InputWindLabPointFromJSONTyped,
    InputWindLabPointToJSON,
} from './InputWindLabPoint';

/**
 * 
 * @export
 * @interface InputWindLabRequest
 */
export interface InputWindLabRequest {
    /**
     * 
     * @type {number}
     * @memberof InputWindLabRequest
     */
    altitudeM: number;
    /**
     * 
     * @type {Array<InputWindLabPoint>}
     * @memberof InputWindLabRequest
     */
    path: Array<InputWindLabPoint>;
    /**
     * 
     * @type {number}
     * @memberof InputWindLabRequest
     */
    speedKmh: number;
    /**
     * Status — фаза для напряму курсу: airborne_outbound (туди) або airborne_inbound (реверс треку).
     * @type {string}
     * @memberof InputWindLabRequest
     */
    status?: InputWindLabRequestStatusEnum;
}


/**
 * @export
 */
export const InputWindLabRequestStatusEnum = {
    Outbound: 'airborne_outbound',
    Inbound: 'airborne_inbound'
} as const;
export type InputWindLabRequestStatusEnum = typeof InputWindLabRequestStatusEnum[keyof typeof InputWindLabRequestStatusEnum];


/**
 * Check if a given object implements the InputWindLabRequest interface.
 */
export function instanceOfInputWindLabRequest(value: object): boolean {
    if (!('altitudeM' in value)) return false;
    if (!('path' in value)) return false;
    if (!('speedKmh' in value)) return false;
    return true;
}

export function InputWindLabRequestFromJSON(json: any): InputWindLabRequest {
    return InputWindLabRequestFromJSONTyped(json, false);
}

export function InputWindLabRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputWindLabRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'altitudeM': json['altitudeM'],
        'path': ((json['path'] as Array<any>).map(InputWindLabPointFromJSON)),
        'speedKmh': json['speedKmh'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function InputWindLabRequestToJSON(value?: InputWindLabRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'altitudeM': value['altitudeM'],
        'path': ((value['path'] as Array<any>).map(InputWindLabPointToJSON)),
        'speedKmh': value['speedKmh'],
        'status': value['status'],
    };
}

